import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface MaintenanceStatus {
  maintenance_mode: boolean;
  message: string;
}

export const MAINTENANCE_QUERY_KEY = ['maintenance-status'] as const;
export const DEFAULT_MAINTENANCE_MESSAGE =
  'O sistema está em manutenção. Tente novamente em alguns instantes.';

/**
 * Consulta o status público de manutenção (`GET /public/maintenance`).
 * Faz polling periódico e revalida ao focar a janela para refletir rápido a
 * ativação/desativação feita no painel admin.
 */
export function useMaintenanceStatus() {
  return useQuery<MaintenanceStatus>({
    queryKey: MAINTENANCE_QUERY_KEY,
    queryFn: async () => {
      const { data } = await api.get<MaintenanceStatus>('/public/maintenance');
      return data;
    },
    // Atualiza sozinho ao entrar/sair da manutenção, mesmo em abas em segundo
    // plano e sem o usuário recarregar a página.
    refetchInterval: 15_000,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
    staleTime: 0,
    retry: false,
  });
}
